import { render, staticRenderFns } from "./ReviewCategoryEdit.vue?vue&type=template&id=826b10e6"
import script from "./ReviewCategoryEdit.vue?vue&type=script&lang=js"
export * from "./ReviewCategoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports